module.exports = __webpack_public_path__ + "static/seo-hypeboard-4a27fb6a5108ab3352639324b1b2c81a.png";